import React, { useState, useEffect } from 'react';
import { Table } from 'reactstrap';
import * as moment from 'moment';
import styled from 'styled-components'
import Tooltip from '@material-ui/core/Tooltip';
import CurrencyFormat from 'react-currency-format';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import information from 'web/assets/images/information.png';
import { buyerNeedCheckoutRejectApi } from 'redux/actions/checkout';
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import YesNoModal from "web/components/YesNoModal";
import styles from './table.module.scss';
import MobileViewAccordion from './MobileView';

const ReactTable = ({ pageLanguageContents, response, currentPageNumber, callBackFetchApi }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [storedBidId, setStoreBidId] = useState();
  const [pageActive, setPageActive] = useState("");
  const [confirmationComment, setConfirmationComment] = useState("");
  const [activeClass, setActiveClass] = useState({
    buyNow: 'active',
    buyNowCpu: 'active',
    bids: 'active',
    offer: 'active'
  });

  useEffect(() => {
    setPageActive("");
    if (response.bidDetails && response.bidDetails.length !== 0) {
      setActiveClass({ bids: "active" });
      setPageActive("Bids");
    }
  }, [response]);

  let bidTableHeaders = [
    { title: pageLanguageContents?.TableHeaders[0]?.Name, },
    { title: pageLanguageContents?.TableHeaders[1]?.OfferedPrice, },
    // { title: pageLanguageContents?.TableHeaders[2]?.Quantity, },
    { title: "Qty" },
    { title: pageLanguageContents?.TableHeaders[6]?.Date, },
    { title: pageLanguageContents?.TableHeaders[7]?.Time, },
    // { title: pageLanguageContents?.TableHeaders[8]?.TransportType, },
    { title: "Mode" },
    { title: pageLanguageContents?.TableHeaders[5]?.BidStatus, },
    { title: '' }
  ];

  const timeFormat = (timeString) => {
    let H = +timeString.substr(0, 2);
    let h = H % 12 || 12;
    let ampm = H < 12 ? ' AM' : ' PM';
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  };

  // need this in case of delivery date outside working hours
  const tootTip = () => {
    return (<Tooltip placement="top" enterTouchDelay={0} arrow title={
      <p>{pageLanguageContents?.Contents[27]?.Alert1}</p>
    }><img src={information} /></Tooltip>)
  }

  const declineBidFunction = async (bidIdVal) => {
    setYesNoModalContent("Are you sure you want to decline this bid?");
    setStoreBidId(bidIdVal);
    setYesNoModal(true);
  };

  const declineBidFunctionConfirmation = async () => {
    let response;
    const token = localStorage.getItem('token');
    let data = {
      authId: localStorage.getItem('authId'),
      bidId: storedBidId,
      comment: confirmationComment ?? null
    }
    response = await dispatch(buyerNeedCheckoutRejectApi(data, token));
    if (response?.success) {
      setAlertType('buyerNeedCheckoutReject');
      setModalContent(response?.data?.msg);
      setModalLink();
      setModal(true);
    } else {
      setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
      setModalLink("");
      setModal(true);
    }
  }

  const tableData = (items, key) => {
    let isAltQty, isAltDate;
    if (items.bidType === "ALTBID") {
      let orgQty = response.lotDetails?.lotPostingOption === 'MULTIPLE' ? response.lotDetails?.qtyPerLot : response.lotDetails?.totalQty;
      let orgDate = new Date(response?.requestedDate);
      let bidDate = new Date(items?.requestedDelDate);
      if (orgDate.getTime() !== bidDate.getTime()) isAltDate = true;
      if (items.qty !== orgQty) isAltQty = true;
    }
    function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    return (
      <tr key={key}>
        <td style={{ fontWeight: items.fcMember ? 'bold' : 'normal' }}>
          <p>{items.bidderLocationInfo}</p>
        </td>
        <td>
          <CurrencyFormat value={items.bidPrice.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </td>
        <td style={{ fontWeight: isAltQty ? 'bold' : 'normal' }}>
          {items.qty && <CurrencyFormat value={items.qty} displayType={'text'} prefix={''} />}
        </td>
        <td style={{ fontWeight: isAltDate ? 'bold' : 'normal' }}>
          {items.requestedDelDate && moment(items.requestedDelDate).format(FORMAT)}
        </td>
        <td>
          {items.appointmentStartTime && timeFormat(items.appointmentStartTime)}-{items.appointmentEndTime && timeFormat(items.appointmentEndTime)}
        </td>
        <td>
          {capitalizeFirstLetter(items.shippingMode)}
        </td>
        <td>{items.bidStatus}</td>
        <td style={{ display: 'flex' }}>
          {(items.bidStatus?.includes('Accepted') || items.bidStatus?.includes('Received')) ?
            <Button
              type='app-green-button'
              handleClick={() => {
                let obj = {
                  id: items.bidId?.toString(),
                  type: 'buyerNeedCheckout'
                }
                dispatch({ type: 'CHECKOUT', payload: obj })
                let obj2 = { selectedPage: currentPageNumber };
                dispatch({ type: "BIDS_PAGINATION", payload: obj2 });
                history.push({ pathname: '/checkout' });
              }}>
              {pageLanguageContents?.Contents[28]?.View}
            </Button>
            : ''
          }
          {(items.bidStatus?.toLowerCase()?.includes('received')) ?
            <div style={{ marginLeft: '10px' }}>
              <Button
                type='app-green-button'
                disabled={!(true)}
                handleClick={() => {
                  declineBidFunction(items.bidId)
                }}
              >
                Decline
              </Button>
            </div>
            : ""
          }
        </td>
      </tr>
    );
  }

  const bidPriceTootTip = () => {
    return (
      <Tooltip placement="top" enterTouchDelay={0} arrow title={<p>Per Pallet</p>}>
        <img style={{ margin: '0px 0px 3px 4px', width: '16px' }} src={information} />
      </Tooltip>
    );
  }

  const bids = () => {
    return (
      <Table responsive>
        <thead>
          <tr>
            {bidTableHeaders.map((items, index) => (
              <th style={{ whiteSpace: 'nowrap' }} key={index}>{items.title}{items.title === 'Bid Price' && bidPriceTootTip()}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {response.bidDetails && response.bidDetails.map((items, key) => (
            tableData(items, key)
          ))}
        </tbody>
      </Table>
    );
  }

  return (
    <>
      <Filter>
        {response.bidDetails?.length > 0 && <span>{pageLanguageContents?.TableHeaders[11]?.FilterBy}</span>}
        {response.bidDetails?.length > 0 &&
          <div className={activeClass.bids} onClick={() => {
            setActiveClass({ bids: "active" });
            setPageActive("Bids");
          }}>
            {pageLanguageContents?.TableHeaders[14]?.Bids}
          </div>
        }
      </Filter>
      <div className={`${styles.tableContainer} ${styles.webView}`}>
        {pageActive === "Bids" && bids()}
      </div>
      <div className={styles.mobileView}>
        {pageActive === "Bids" &&
          <MobileViewAccordion
            currentPageNumber={currentPageNumber}
            items={response.bidDetails}
            timeFormat={timeFormat}
            declineBidFunction={declineBidFunction}
            pageLanguageContents={pageLanguageContents}
            bidPriceTootTip={bidPriceTootTip}
          />
        }
      </div>
      <AlertModal
        isOpen={modal}
        toggle={() => setModal(!modal)}
        title=""
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'buyerNeedCheckoutReject') {
            callBackFetchApi();
          }
        }}
      />
      <YesNoModal
        isOpen={yesNomodal}
        toggle={() => {
          setYesNoModal(!yesNomodal);
          // Reset confirmationComment when the modal is closed
          setConfirmationComment("");
        }}
        title=""
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            declineBidFunctionConfirmation()
          }
        }}
        content={yesNoModalContent}
        link="/"
        enableConfirmationComment={true}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
        confirmationCommentBoxLabel={"Note to Seller"}
      />
    </>
  );
};

export default ReactTable;

const Filter = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  align-items:center;
  > div {    
    border: 1px solid lightgray;
    padding: 5px 10px;
    min-width: 50px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 36px;
    font-size: 17px;
    font-family: 'latobold';
    color: #717171;
    :hover {
      background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
      color: white;
      border: 1px solid lightgray;
    }
  }
  .active {
    background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
    color: white;
    border: 1px solid lightgray;
  }
`;